module.exports = __webpack_public_path__ + "img/key_value.707d4404.svg";